import React from 'react';
import { Wallet } from 'lucide-react';
import { CAMP_SEASON, PRICING } from './summerCampContent';
export function SummerCampPricing() {
  return <section className="py-24 bg-paper border-y border-subtle-gray" data-id="element-3263">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3264">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-3265">
          <h2 className="text-4xl md:text-5xl text-ink mb-6" data-id="element-3266">
            Summer Camp Pricing
          </h2>
          <p className="text-xl text-gray-warm" data-id="element-3267">
            Simple weekly pricing. Pay by the week, or ask about paying by the
            day.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12" data-id="element-3268">
          {PRICING.map((tier, idx) => {
          const isEnrolled = idx >= 2;
          return <div key={idx} className={`relative rounded-2xl p-8 border-2 transition-all ${isEnrolled ? 'bg-ink border-storm-red text-white shadow-xl' : 'bg-off-white border-subtle-gray hover:border-storm-red/40 hover:shadow-lg'}`} data-id="element-3269">
                {isEnrolled && <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-gold text-ink px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide whitespace-nowrap" data-id="element-3270">
                    Storm Member
                  </div>}
                <h3 className={`text-xl mb-4 ${isEnrolled ? 'text-white' : 'text-ink'}`} data-id="element-3271">
                  {tier.title}
                </h3>
                <p className={`font-display text-5xl mb-1 ${isEnrolled ? 'text-storm-red' : 'text-ink'}`} data-id="element-3272">
                  {tier.price}
                </p>
                <p className={`text-sm uppercase tracking-wide font-bold mb-4 ${isEnrolled ? 'text-gray-warm' : 'text-gray-warm'}`} data-id="element-3273">
                  {tier.sub}
                </p>
                <p className={isEnrolled ? 'text-gray-warm' : 'text-gray-warm'} data-id="element-3274">
                  {tier.copy}
                </p>
              </div>;
        })}
        </div>

        <div className="max-w-3xl mx-auto bg-off-white rounded-2xl p-6 border border-subtle-gray flex items-start gap-4" data-id="element-3275">
          <Wallet className="w-6 h-6 text-storm-red shrink-0 mt-1" data-id="element-3276" />
          <div data-id="element-3277">
            <p className="font-bold text-ink mb-1" data-id="element-3278">
              Daily Payment Option Available
            </p>
            <p className="text-gray-warm" data-id="element-3279">
              Can't commit to a full week? You can also pay by the day. Text or
              call{' '}
              <a href={`tel:${CAMP_SEASON.registrationPhone}`} className="font-bold text-storm-red hover:underline" data-id="element-3280">
                {CAMP_SEASON.registrationPhone}
              </a>{' '}
              to ask about daily pricing and availability.
            </p>
          </div>
        </div>
      </div>
    </section>;
}